module.exports = __webpack_public_path__ + "assets/images/premium-features/shift-tasks-banner-new-a0a1b2.png";